'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { LegacyIcon, LegacyIconName, useAuthSignInClick, useUserSession } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';
export default function LegacyHeaderPersonIcon() {
  const $ = _c(7);
  const router = useRouter();
  const {
    user
  } = useUserSession();
  const {
    handleSignInClick
  } = useAuthSignInClick();
  let t0;
  if ($[0] !== handleSignInClick || $[1] !== router || $[2] !== user) {
    t0 = () => {
      if (user) {
        return router.push(NAVIGATION_URLS.velocity.account.aboutYou);
      }
      handleSignInClick();
    };
    $[0] = handleSignInClick;
    $[1] = router;
    $[2] = user;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleClickPersonIcon = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LegacyIcon aria-hidden="true" name={LegacyIconName.PERSON} isPriority={true} size={20} />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== handleClickPersonIcon) {
    t2 = <button type="button" onClick={handleClickPersonIcon} title="Rewards & Account" data-testid="legacy-header-account-link" className="legacy-header__person">{t1}</button>;
    $[5] = handleClickPersonIcon;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}